import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { throttle } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'DragScrollHelper',
  props: {
    scrollContainerSelector: null
  },
  setup(__props: any) {

const props = __props as { scrollContainerSelector: string }



const scroller = ref()
const showScrollRegions = ref(false)

// fiddle with these numbers until drag scrolling feels decent
const throttleTime = 10
const scrollAmount = 10

const throttledScroll = throttle(function (direction: 'up' | 'down') {
  if (!scroller.value) {
    scroller.value = document.querySelector(props.scrollContainerSelector)
  }

  const directionMultiplier = direction === 'up' ? -1 : 1
  const scrollAmountWithDirection = scrollAmount * directionMultiplier

  scroller.value.scroll({
    top: scroller.value.scrollTop + scrollAmountWithDirection,
    behavior: 'instant',
  })
}, throttleTime)

const onDragStartListener = () => {
  showScrollRegions.value = true
}

const onDragEndListener = () => {
  showScrollRegions.value = false
}

const onDropListener = () => {
  showScrollRegions.value = false
}

onMounted(() => {
  document.addEventListener('dragstart', onDragStartListener)
  document.addEventListener('dragend', onDragEndListener)
  document.addEventListener('drop', onDropListener)
})

onUnmounted(() => {
  document.removeEventListener('dragstart', onDragStartListener)
  document.removeEventListener('dragend', onDragEndListener)
  document.removeEventListener('drop', onDropListener)
})

return { __sfc: true,props, scroller, showScrollRegions, throttleTime, scrollAmount, throttledScroll, onDragStartListener, onDragEndListener, onDropListener }
}

})